// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TnmuiMCZ5Qrwbd {
  margin-bottom: 0;
  padding: 20px 14px 14px;
  font-size: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--ds-text, #172b4d);
  text-decoration: none;
}
.TnmuiMCZ5Qrwbd:hover,
.TnmuiMCZ5Qrwbd:active {
  background-color: transparent;
  color: var(--ds-text-brand, #0c66e4);
  text-decoration: none;
}
.MmubCjgqXqUdfk {
  margin-bottom: 0;
  padding: 20px 14px 14px;
  font-size: 16px;
  gap: 4px;
}
.MmubCjgqXqUdfk:hover,
.MmubCjgqXqUdfk:active {
  background-color: transparent;
  color: var(--ds-text-brand, #0c66e4);
  text-decoration: none;
}
.MmubCjgqXqUdfk svg {
  width: 8px;
  height: auto;
}
.MmubCjgqXqUdfk[data-active='true'] {
  color: var(--ds-text-brand, #0c66e4);
}
.nsPqAN3eKpRlbi {
  display: flex;
  position: relative;
}
.IgIIns76PZkTnu {
  position: absolute;
  bottom: 0;
  height: 2px;
  transition: left 0.3s ease, width 0.3s ease;
  background-color: var(--ds-background-brand-bold, #0c66e4);
}
@media (prefers-reduced-motion: reduce) {
  .IgIIns76PZkTnu {
    transition: none;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabLink": `TnmuiMCZ5Qrwbd`,
	"tabButton": `MmubCjgqXqUdfk`,
	"tabGroup": `nsPqAN3eKpRlbi`,
	"underline": `IgIIns76PZkTnu`
};
export default ___CSS_LOADER_EXPORT___;
